import { Chip, ListItem, ListItemText, Stack, listItemSecondaryActionClasses } from '@mui/material'

interface Dimension {
  label: string
  value: string
  price?: number
  showPrice?: boolean
}

interface CompactDimensionsProps {
  dimensions: Dimension[]
  subtitle?: string
}

/**
 * Returns signed price suffix (e.g. ` +$1.50`)
 * or empty string if price is undefined or hidden.
 */
const formatPrice = (dimension: Dimension) => {
  if (!dimension.showPrice || dimension.price === undefined) return ''
  const sign = dimension.price >= 0 ? '+' : ''
  return ` ${sign}$${dimension.price.toFixed(2)}`
}

const CompactDimensions = (props: CompactDimensionsProps) => {
  const { dimensions, subtitle = 'Dimensions' } = props

  if (dimensions.length === 0) return null

  return (
    <ListItem
      disableGutters
      disablePadding
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        [`.${listItemSecondaryActionClasses.root}`]: {
          position: 'static',
        },
      }}
    >
      <ListItemText primary={subtitle} />
      <Stack sx={{ flexFlow: 'row wrap', gap: 0.5, gridColumn: '1 / -1', my: 0.5, order: 3 }}>
        {dimensions.map((dimension, index) => (
          <Chip key={index} size="small" label={`${dimension.label}: ${dimension.value}${formatPrice(dimension)}`} />
        ))}
      </Stack>
    </ListItem>
  )
}

export default CompactDimensions
